import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { CopyIcon } from "../../assets/icons/icons";
import CreateAbhaNumber from "../../components/CreateAbhaNumber/CreateAbhaNumber";
import ProcessSuccess from "../../components/ProcessSuccess/ProcessSuccess";
import {
  ArrowIcon,
  CircleWithTickIcon,
  ExclamatoryIcon,
  InfoIcon
} from "../../front-end-global-components/assets/assets";
import Button from "../../front-end-global-components/components/Button/Button";
import ConditionalRender from "../../front-end-global-components/components/ConditionalRender/ConditionalRender";
import FeatureFlagsFallback from "../../front-end-global-components/components/FeatureFlagsFallback/FeatureFlagsFallback";
import Header from "../../front-end-global-components/components/Header/Header";
import InputBox from "../../front-end-global-components/components/InputBox/InputBox";
import Modal from "../../front-end-global-components/components/Modal/Modal";
import OTPInputBox from "../../front-end-global-components/components/OTPInputBox/OTPInputBox";
import RoundedProfilePicture from "../../front-end-global-components/components/RoundedProfilePicture/RoundedProfilePicture";
import {
  registerNewAbhaNumber,
  setAbdmTransactionId
} from "../../redux/abdm/actions";
import { logout } from "../../redux/authentication/actions";
import {
  clearShowSuccess,
  linkHealthIdNumber,
  setAuthModes,
  setTransactionId
} from "../../redux/patients/actions";
import {
  formatABHANumber,
  generateEncryptionValue
} from "../../utils/constants";
import {
  isValidArray,
  isValidObject,
  validation
} from "../../utils/validators";
import AbdmCard from "../ShowAbdmInfo/AbdmCard";

const AbhaNumber = (props) => {
  const [healthIdData, setHealthIdData] = useState({});

  const navigate = useNavigate();
  useEffect(() => {
    const { currentProfile, healthIdData } = props.patients;
    if (currentProfile && healthIdData?.[currentProfile]) {
      setHealthIdData(healthIdData[currentProfile]);
    }
    // eslint-disable-next-line
  }, [props.patients.currentProfile, props.patients.healthIdData]);

  return (
    <>
      <Routes>
        <Route
          path="/*"
          element={
            <>
              <Header
                supportIconOnClick={() => {
                  navigate("/query");
                }}
                title="ABHA Number"
                backButtonOnClick={() => {
                  navigate("/settings");
                }}
                incident={props.app.featureFlags?.incident?.patients}
                incidentOnClick={() => {
                  navigate("/incidents");
                }}
              />
              {!props.app.featureFlags?.abhaService && (
                <FeatureFlagsFallback height={"remaining-body-height"} />
              )}

              {props.app.featureFlags?.abhaService && (
                <ABHANumberMenu
                  transactionId={props.abdm.transactionId}
                  patients={props.patients}
                  healthIdData={healthIdData}
                />
              )}
            </>
          }
        />
        <Route path="viewCard" element={<AbdmCard type="ABHA Number" />} />
      </Routes>

      <Routes>
        <Route
          path="link"
          element={
            <LinkUnlinkAbhaNumber
              patients={props.patients}
              healthIdData={healthIdData}
            />
          }
        />
        <Route
          path="unlink"
          element={
            <LinkUnlinkAbhaNumber
              patients={props.patients}
              healthIdData={healthIdData}
            />
          }
        />
        <Route
          path="create/*"
          element={
            <CreateAbhaNumber
              auth={props.auth}
              transactionId={props.abdm.transactionId}
              accessToken={props.auth.data.accessToken}
              abhaNumberDetails={props.abdm.newHealthNumberData}
              isHealthIdExists={props.abdm.healthIdExists}
              loading={props.abdm.loading}
              closeModal={() => {
                setAuthModes(null);
                navigate("/settings/abhaNumber");
                if (props.abdm.newHealthNumberData) {
                  registerNewAbhaNumber({
                    clearNewHealthNumberData: true
                  });
                }
              }}
            />
          }
        />
      </Routes>
    </>
  );
};

const mapStateToProps = (state) => ({
  patients: state.patients,
  abdm: state.abdm,
  auth: state.auth,
  app: state.app
});

export default connect(mapStateToProps)(AbhaNumber);

const ABHANumberMenu = (props) => {
  const navigate = useNavigate();

  const profilePhoto = () => {
    return isValidObject(props.healthIdData) && props.healthIdData.profilePhoto
      ? `data:image/png;base64, ${props.healthIdData.profilePhoto}`
      : null;
  };
  return (
    <>
      <div className=" padding-larger border-bottom-1px-e5e5e5">
        <div className=" display-flex flex-align-items-center">
          <RoundedProfilePicture
            data-cy={`profilePic-${""}`}
            size={"medium"}
            src={profilePhoto()}
            alt=""
            loading={props.patients.loading}
          />

          <div className=" font-size-small padding-left-large font-color-secondary">
            <div>{props.healthIdData?.fullName || " "}</div>
            <div className=" padding-top-small">
              ABHA Number - {props.healthIdData?.abhaNumber || "Nil"}
            </div>
            <div className=" padding-top-small">
              ABHA Address - {props.healthIdData?.abhaAddress || "Nil"}
            </div>
          </div>
        </div>

        <div className=" font-size-small display-flex flex-align-items-center flex-justify-content-center padding-top-large">
          <div>
            {props.healthIdData?.kycStatus === "VERIFIED"
              ? "KYC Verified"
              : "Self Declared"}
          </div>
          <div className="display-flex flex-align-items-center padding-left-default">
            {props.healthIdData?.kycStatus === "VERIFIED" ? (
              <CircleWithTickIcon
                circleColor={"white"}
                circleOutline={"#00a000"}
                tickColor={"#00a000"}
              />
            ) : (
              <ExclamatoryIcon />
            )}
          </div>
        </div>
      </div>

      <div className=" padding-horizontal-larger">
        {!props.healthIdData?.abhaNumber && (
          <div
            className="display-flex flex-grow-1 flex-align-items-center padding-top-larger "
            data-cy="link-abha-address"
          >
            <div
              className="flex-grow-1 flex-direction-column display-flex font-color-secondary"
              onClick={() => {
                setAuthModes(null);
                navigate("/settings/abhaNumber/link");
                setTransactionId(null);
              }}
            >
              <span className="font-size-medium font-family-gilroy-regular">
                Link ABHA Number
              </span>
              <span className="font-size-small font-family-gilroy-regular text-transform-capitalize padding-top-small">
                Link selected ABHA address with your ABHA number
              </span>
            </div>
            <ArrowIcon />
          </div>
        )}

        {props.healthIdData?.abhaNumber && (
          <MenuCard
            data-cy="UNLINK-ABHA-ADDRESS"
            title="Unlink ABHA Number"
            description="Unlink the selected ABHA address associated with your ABHA number"
            onCardClick={() => {
              setAuthModes(null);
              navigate("/settings/abhaNumber/unlink");
              setTransactionId(null);
            }}
          />
        )}

        <MenuCard
          data-cy="CREATE-ABHA-NUMBER"
          title="Create ABHA Number"
          description="Register for a new ABHA number to uniquely identify your health records"
          onCardClick={() => {
            setAuthModes(null);
            navigate("/settings/abhaNumber/create");
            setAbdmTransactionId(null);
          }}
        />

        {/* {props.healthIdData?.abhaNumber && (
          <MenuCard
            data-cy="SHOW-ABHA-NUMBER-CARD"
            title="Show ABHA Number Card"
            description="View,share and download your ABHA number card"
            onCardClick={() => {
              setAuthModes(null);
              navigate("/settings/abhaNumber/viewCard");
              setAbdmTransactionId(null);
            }}
          />
        )} */}
      </div>
    </>
  );
};

const MenuCard = (props) => {
  return (
    <div
      className="display-flex flex-grow-1 flex-align-items-center padding-top-larger "
      data-cy={props?.["data-cy"]}
    >
      <div
        className="flex-grow-1 flex-direction-column display-flex font-color-secondary"
        onClick={props.onCardClick}
      >
        <span className="font-size-medium font-family-gilroy-regular">
          {props.title}
        </span>
        <span className="font-size-small font-family-gilroy-regular text-transform-capitalize padding-top-small">
          {props.description}
        </span>
      </div>
      <ArrowIcon />
    </div>
  );
};

const LinkUnlinkAbhaNumber = (props) => {
  const [selectedAuthMode, setSelectedAuthMode] = useState("");
  const [showOtpBox, setShowOtpBox] = useState(false);
  const [OTP, setOTP] = useState("");
  const [abhaNumber, setAbhaNumber] = useState("");
  const [counter, setCounter] = useState(null);
  const [resendCount, setResendCount] = useState(0);
  const [running, setRunning] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const [showInfo, setShowInfo] = useState(true);

  const isLinkMode = location.pathname.includes("/link");
  const isUnlinkMode = location.pathname.includes("/unlink");

  // Timer logic
  useEffect(() => {
    let counterTimer;
    if (
      props.patients?.transaction?.id &&
      counter &&
      typeof counter === "number" &&
      running
    ) {
      counterTimer = setTimeout(() => {
        setCounter(counter - 1);
      }, 1000);
      return;
    }
    setCounter(null);
    setRunning(false);
    return () => clearTimeout(counterTimer);
    // eslint-disable-next-line
  }, [counter]);

  useEffect(() => {
    if (
      props.patients?.transaction?.id &&
      typeof props.patients?.transaction?.id === "string" &&
      !running
    ) {
      setCounter(60);
      setRunning(true);
    } else {
      setCounter(null);
      setRunning(false);
    }
    // eslint-disable-next-line
  }, [props.patients?.transaction?.id]);

  const handleClose = () => {
    setCounter(null);
    setRunning(false);
    setShowOtpBox(false);

    setTransactionId(null);
    setAuthModes(null);
    navigate("/settings/abhaNumber");
  };

  const handleAuthModeClick = (authMode) => {
    setSelectedAuthMode(authMode);
    const abhaNumberToUse = isLinkMode
      ? abhaNumber
      : props.healthIdData?.abhaNumber;

    linkHealthIdNumber(
      {
        abhaNumber: generateEncryptionValue(
          formatABHANumber(abhaNumberToUse),
          "ABHA"
        ),
        authMode
      },

      "init"
    );
    setShowOtpBox(true);
  };
  const handleOtpSubmit = (event) => {
    event.preventDefault();

    const otpAction = isLinkMode ? "verifyOtpLink" : "verifyOtpDeLink";
    const abhaNumberToUse = isLinkMode
      ? abhaNumber
      : props.healthIdData?.abhaNumber;
    linkHealthIdNumber(
      {
        ...(isLinkMode
          ? {
              abhaNumber: generateEncryptionValue(
                formatABHANumber(abhaNumberToUse),
                "ABHA"
              )
            }
          : {}),
        value: generateEncryptionValue(OTP, "ABHA"),
        authMode: selectedAuthMode,
        transactionId: props.patients?.transaction?.id
      },
      otpAction
    );
    setShowOtpBox(false);
  };

  const handleResendOtp = () => {
    // Disable only for first 2 resends when timer is running
    if (
      typeof counter === "number" &&
      !props.patients.loading &&
      resendCount < 2
    ) {
      return;
    }

    const abhaNumberToUse = isLinkMode
      ? abhaNumber
      : props.healthIdData?.abhaNumber;
    linkHealthIdNumber(
      {
        abhaNumber: generateEncryptionValue(
          formatABHANumber(abhaNumberToUse),
          "ABHA"
        ),
        authMode: selectedAuthMode
      },
      "init"
    );
    // Start counter only for first 2 resends

    if (resendCount < 2) {
      setCounter(60);
    }
    setResendCount((prev) => prev + 1);
  };

  const getSuccessConfig = () => {
    return isLinkMode
      ? {
          title: (
            <>
              Congratulations!{" "}
              <b>
                {" "}
                {
                  props.patients.profiles?.[props.patients.currentProfile]?.name
                }{" "}
              </b>{" "}
              Your ABHA number is now linked to your existing ABHA address. ABHA
              number is visible on your profile
            </>
          ),
          alternative: true
        }
      : {
          title: (
            <>
              ABHA number is unlinked from{" "}
              <b>{props.healthIdData?.abhaAddress}</b>.
            </>
          ),
          alternative: false
        };
  };

  useEffect(() => {
    setTransactionId(null);
  }, []);

  return (
    <Modal
      show={true}
      onClose={handleClose}
      canIgnore={true}
      position="position-fixed bottom-0 left-0 right-0"
      boxShadow="none"
      width="inherit-parent-width"
      background="background-transparent"
      height="height-fit-to-content"
    >
      <div className="background-white padding-larger box-shadow-default font-color-secondary">
        <ConditionalRender
          condition={
            !isValidArray(props.patients?.authModes) &&
            typeof props.patients?.transaction?.id !== "string" &&
            props.patients.showSuccess?.healthId?.link === false &&
            props.patients.showSuccess?.healthId?.unLink === false
          }
        >
          {showInfo && (
            <>
              <div className="text-align-center font-family-gilroy-regular font-size-small">
                <InfoIcon />
              </div>
              <div className="text-align-center font-family-gilroy-regular padding-top-larger">
                ABHA NUMBER UPDATE NOTICE
              </div>
              <div className="text-align-center font-family-gilroy-regular font-size-smaller font-color-red padding-top-large">
                You’ll be logged out after updating your ABHA number. Please log
                in again to continue.
              </div>
              <div className="display-flex padding-top-larger">
                <Button
                  text="Confirm"
                  boxShadow={false}
                  required
                  type="button"
                  className={"margin-top-default"}
                  data-cy={"notice-confirm-button"}
                  loading={props.patients.loading}
                  onClick={() => {
                    setShowInfo(false);
                  }}
                />
              </div>
            </>
          )}
          {!showInfo && isLinkMode && (
            <>
              <div className="text-align-center font-family-gilroy-regular font-size-small text-uppercase">
                LINK ABHA NUMBER
              </div>
              <form
                onChange={(event) => {
                  setAbhaNumber(event.target.value);
                }}
                onSubmit={(event) => {
                  event.preventDefault();
                  linkHealthIdNumber({ abhaNumber }, "search");
                }}
              >
                <InputBox
                  className="inherit-parent-width border-radius-default margin-vertical-large"
                  name="abhaNumber"
                  label="ABHA Number"
                  value={abhaNumber}
                  type="number"
                  autoComplete="off"
                  required
                  data-cy="abha-number-field"
                  validation={(value) => validation("abhaNumber", value)}
                />
                <Button
                  text="Continue"
                  variant="primary"
                  boxShadow={false}
                  required
                  type="submit"
                  disabled={abhaNumber.length !== 14}
                  className={"margin-top-default"}
                  data-cy={"Link-abha-address-button"}
                  loading={props.patients.loading}
                />
              </form>
            </>
          )}

          {!showInfo && isUnlinkMode && (
            <>
              <div className="text-align-center font-family-gilroy-regular font-size-small">
                CONFIRMATION
              </div>
              <div className="text-align-center font-family-gilroy-regular padding-top-larger">
                Are you sure you want to unLink ABHA number{" "}
                {props.healthIdData?.abhaNumber} from{" "}
                {props.healthIdData?.abhaAddress} ?
              </div>
              <div className="text-align-center font-family-gilroy-regular font-size-smaller font-color-red padding-top-large">
                You can share records through ABHA address even after unlinking
                ABHA number
              </div>
              <div className="display-flex padding-top-larger">
                <Button
                  text="Yes"
                  boxShadow={false}
                  required
                  type="button"
                  className={"margin-top-default margin-right-default"}
                  data-cy={"create-new-demographic-button"}
                  loading={props.patients.loading}
                  onClick={() => {
                    linkHealthIdNumber(
                      { abhaNumber: props.healthIdData?.abhaNumber },
                      "search"
                    );
                  }}
                />
                <Button
                  text="No"
                  variant={"secondary"}
                  boxShadow={false}
                  required
                  type="button"
                  className={"margin-top-default margin-left-default"}
                  data-cy={"cancel-create-demographic-button"}
                  onClick={handleClose}
                />
              </div>
            </>
          )}
        </ConditionalRender>

        {/* Auth Mode Selection - Same for both */}
        <ConditionalRender
          condition={
            isValidArray(props.patients?.authModes) &&
            !showOtpBox &&
            props.patients.showSuccess?.healthId?.link === false &&
            props.patients.showSuccess?.healthId?.unLink === false
          }
        >
          <div className="text-align-center font-size-small padding-bottom-large">
            Validate ABHA Number by selecting any one of the options
          </div>

          <ConditionalRender
            condition={props.patients?.authModes?.includes("MOBILE_OTP")}
          >
            <AuthModeCard
              isLast={false}
              data-cy="phone"
              onCardClick={() => {
                handleAuthModeClick("MOBILE_OTP");
              }}
              title="Mobile Number"
              description="OTP will be sent to your registered Phone number"
            />
          </ConditionalRender>

          <ConditionalRender
            condition={props.patients?.authModes?.includes("AADHAAR_OTP")}
          >
            <AuthModeCard
              isLast={true}
              data-cy="Aadhaar"
              onCardClick={() => {
                handleAuthModeClick("AADHAAR_OTP");
              }}
              title="Aadhaar Number"
              description="OTP will be sent to your registered Aadhaar number"
            />
          </ConditionalRender>
        </ConditionalRender>

        {/* OTP Verification - Same for both */}
        <ConditionalRender
          condition={
            (typeof props.patients?.transaction?.id === "string" ||
              showOtpBox) &&
            props.patients.showSuccess?.healthId?.link === false &&
            props.patients.showSuccess?.healthId?.unLink === false
          }
        >
          <form onSubmit={handleOtpSubmit}>
            <OTPInputBox
              name="otp"
              autoFocus={true}
              value={OTP}
              setValue={(otpValue) => {
                setOTP(otpValue);
              }}
              required
              className="margin-bottom-large"
            />
            <div className="display-flex flex-justify-content-space-between font-size-medium margin-bottom-larger">
              {resendCount >= 2 ? (
                <div className="font-color-secondary font-size-small">
                  OTP Resend limit reached. Try after 30 minutes.
                </div>
              ) : (
                <>
                  {counter &&
                  typeof counter === "number" &&
                  resendCount <= 2 ? (
                    <div>{`00:${counter
                      .toString()
                      .padStart(2, "0")} seconds`}</div>
                  ) : (
                    <div />
                  )}
                  {counter ? (
                    <div />
                  ) : (
                    <div
                      className={`${
                        typeof counter === "number" &&
                        !props.patients.loading &&
                        resendCount < 2
                          ? "font-color-tertiary"
                          : "font-color-primary"
                      }`}
                      onClick={handleResendOtp}
                    >
                      Resend OTP
                    </div>
                  )}
                </>
              )}
            </div>

            <Button
              text="Continue"
              variant={"primary"}
              boxShadow={false}
              required
              type="submit"
              disabled={OTP.length !== 6}
              data-cy={"CONTINUE-BUTTON"}
              loading={props.patients.loading}
            />
          </form>
        </ConditionalRender>

        {/* Success Screen - Different content for Link/Unlink */}
        <ConditionalRender
          condition={
            props.patients.showSuccess?.healthId?.link === true ||
            props.patients.showSuccess?.healthId?.unLink === true
          }
        >
          <ProcessSuccess
            title={getSuccessConfig().title}
            alternative={getSuccessConfig().alternative}
            description={
              <div className="inherit-parent-width">
                <div className="display-flex">
                  <div>ABHA ADDRESS : </div>

                  <div className="font-family-gilroy-bold padding-left-default">
                    {props.healthIdData?.abhaAddress}
                  </div>

                  <div
                    className="cursor-pointer padding-left-default"
                    onClick={() => {
                      navigator.clipboard.writeText(
                        props.healthIdData?.abhaAddress
                      );
                    }}
                  >
                    <CopyIcon />
                  </div>
                </div>
                {isLinkMode && (
                  <div className="display-flex">
                    <div className="">ABHA NUMBER &nbsp; : </div>

                    <div className="font-family-gilroy-bold padding-left-default">
                      {abhaNumber}
                    </div>

                    <div
                      className="cursor-pointer padding-left-default"
                      onClick={() => {
                        navigator.clipboard.writeText(abhaNumber);
                      }}
                    >
                      <CopyIcon />
                    </div>
                  </div>
                )}
              </div>
            }
            information="You need to login again to receive the updated information. Click continue to logout."
            confirmClick={() => {
              clearShowSuccess();
              logout(true);
              // navigate("/abhaNumber");
            }}
          />
        </ConditionalRender>
      </div>
    </Modal>
  );
};

const AuthModeCard = (props) => {
  return (
    <div
      className={`display-flex flex-grow-1 flex-align-items-center ${
        props.isLast ? "" : "padding-bottom-large"
      }`}
      data-cy={props["data-cy"]}
    >
      <div
        className="flex-grow-1 flex-direction-column display-flex font-color-secondary"
        onClick={props.onCardClick}
      >
        <span className="font-size-medium font-family-gilroy-regular">
          {props.title}
        </span>
        <span className="font-size-small font-family-gilroy-regular text-transform-capitalize padding-top-small">
          {props.description}
        </span>
      </div>
      <ArrowIcon />
    </div>
  );
};
